var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Window',{ref:"window",attrs:{"title":'Game',"top":10,"left":420}},[_c('div',{staticClass:"content"},[_c('canvas',{ref:"canvas"})])])}
var staticRenderFns = []

export { render, staticRenderFns }